import { ClassValue, clsx } from 'clsx';
import { twMerge as tw } from 'tailwind-merge';

export function TwMerge(...inputs: ClassValue[]) {
  return tw(clsx(inputs));
}
